export const OKTA = "okta";
export const OKTA_LABEL = "Okta";
export const OKTA_APPLICATION_ID_TITLE = "Application Client ID";
export const OKTA_APPLICATION_SECRET_TITLE = "Application Secret";
export const OKTA_AUTHENTICATION_AUDIENCE_TITLE =
  "Authentication Server Audience";
export const OKTA_AUTHENTICATION_ID_TITLE = "Authentication Server ID";
export const OKTA_ACCOUNT_DOMAIN_TITLE = "Okta Account Domain";
export const OKTA_REDIRECT_URL_TITLE = "Redirect URL";
export const OKTA_AUTHENTICATION_TITLE = "Okta Authentication";

export const SMTP = "smtp";
export const SMTP_LABEL = "SMTP";
export const SMTP_FROM_ADDR_TITTLE = "From address";
export const SMTP_TO_ADDR_TITTLE = "To address";
export const SMTP_LOGIN_TITTLE = "Login";
export const SMTP_PASSWORD_TITTLE = "Password";
export const SMTP_PORT_TITTLE = "Port";
export const SMTP_SERVER_TITTLE = "Server";

export const ACTION_LOG = "action_log";
export const ACTION_LOG_LABEL = "Action log";
export const ACTION_LOG_ROTATION_PERIOD_TITLE = "Rotation period, years";
export const ACTION_LOG_ROTATION_PERIOD_DETAILS_TITLE = "Rotation period";

export const FTP = "proftpd";
export const FTP_LABEL = "FTP";
export const FTP_MASQUERADE_ADDRESS_TITTLE = "Masquerade address";
